import { releaseStatusOf } from '../../constants/release-status';

export interface ReleaseBadgeProps {
  isReleased: boolean;
}

/** Status as a chip — used where there is nothing to toggle (the course list). */
const ReleaseBadge = ({ isReleased }: ReleaseBadgeProps) => {
  const status = releaseStatusOf(isReleased);

  return (
    <span className={`text-[11px] font-semibold px-2 py-1 rounded-full flex items-center gap-1.5 shrink-0 ${status.chip}`}>
      <span className={`w-[7px] h-[7px] rounded-full shrink-0 ${status.lamp}`} />
      {status.label}
    </span>
  );
};

export default ReleaseBadge;
